import Navigator from "../Navigator.js";
import SpaceSelect from "./SpaceSelect/SpaceSelect.js";
import SpaceDetails from "./SpaceDetails/SpaceDetails.js";
import Floor from "../Floor/Floor.js";
import Animation from "@templates/App/Animation.js";
import Popup from "@templates/Components/Popup/Popup.js";
import NavigatorRouter from "@modules/navigator/Navigator.router.js";
import GallerySlider from "@modules/gallery/GallerySlider.js";

const Space = {
    height: 0,

    init() {
        this.el = $('[component="Space"]');
        if (!this.el.length) return;

        this.spacePlan = this.el.find(".spacePlan .img");
        this.details = this.el.find(".details");
        this.priceListUrl = this.el.find(".priceListUrl");
        this.name = this.el.find('.name');
        this.type = this.el.find('.type');
        this.sixe = this.el.find('.size');
        this.price = this.el.find('.price');
        this.buttonInterest = this.el.find(".interest");
        this.compass = this.el.find(".navigator-head .compass");
        this.popup = $('[component="Popup"][name="interest"]');
        this.popupGallery = $('[component="Popup"][name="space-gallery"]');
        this.popupVR = $('[component="Popup"][name="vr"]');
        this.popupPlanZoom = $('[component="Popup"][name="planzoom"]');

        this.bind();
    },

    prepare() {
        this.fill();
        this.getFlatDetails();
        this.preparePopup();
        this.updatePriceListUrl();
        Popup.initOpener(this.el);
        SpaceSelect.init();
    },

    bind() {
        this.bindInterestButton('.interest');

        this.el.find('button.close.space').unbind('click').click((evt) => {
            NavigatorRouter.setSpace(null);
        })

        $(document).on('keydown.closeSpace', (e) => {
            setTimeout(() => {
                if (e.key === 'Escape' && this.data) {
                    NavigatorRouter.setSpace(null);
                }
            }, 200);
        });
    },

    bindInterestButton(element = ".spaceDetails .interest") {
        this.el.find(element).click((evt) => {
            this.popup.find('input[name="flat_name"]').val(this.data.name);
            this.popup.find('input[name="flat_id"]').val(this.data.id);
        });
    },

    show(data) {
        if (Space.isSold(data)) {
            return;
        }
        this.data = data;
        this.el.addClass('show');
        this.resize();
        this.prepare();
    },

    hide() {
        this.el.removeClass('show');
    },

    animate() {
        const _old = this.spacePlan.find('img');
        const _new = $('<img src="' + this.data.plan_image + '" alt="">').prependTo(this.spacePlan);

        const from = {scale: 0.9, opacity: 0, filter: "blur(3px)", duration: 0.5};
        const to = {scale: 1, opacity: 1, filter: "blur(0px)", duration: 0.5};

        Animation.switch(_old, _new, from, to, () => {
            this.resize();
            Navigator.setHeight();
        })
    },

    updatePriceListUrl() {
        let href = $(this.priceListUrl).attr("href");
        href = href.replaceAll("X", Floor.number);

        $(this.priceListUrl).attr("href", href);
    },

    fill() {
        this.type.text(this.data.type);
        this.name.text(this.data.name);
        this.sixe.text(NAVIGATOR_META.roomSize[this.data.rooms_count].text);
        this.price.text(this.getPrice());
        this.price.toggleClass("without", !this.data.price_with_tax);
        this.buttonInterest.toggleClass("disabled", this.isSold(this.data));
        this.compass.attr("class", "compass orientation" + this.data.orientation);
    },

    getPrice() {
        if (this.isSold(this.data)) {
            return NAVIGATOR_META.text["sell_end"];
        }

        if (this.isReserved(this.data)) {
            return NAVIGATOR_META.text["missing_price2"];
        }

        if (this.isInDev(this.data)) {
            return NAVIGATOR_META.text["missing_price3"];
        }

        if (!this.data.price_with_tax) {
            return NAVIGATOR_META.text["missing_price"];
        } else {
            return Navigator.formatPrice(this.data.price_with_tax);
        }
    },

    getFlatDetails() {
        let formData = new FormData();
        formData.append('action', 'details');
        formData.append('flat', this.data.id);
        $.ajax({
            type: 'POST',
            url: WEB_ROOT + '/modules/navigator/Navigator.async.php',
            data: formData,
            dataType: "json",
            processData: false,
            contentType: false,

            success: (response, textStatus, jqXHR) => {
                if (response.view) {
                    Space.details.html(response.view);
                    SpaceDetails.init();

                    Space.popupGallery.find('.gallery').html(response.view_gallery);
                    GallerySlider.init();

                    this.popupVR.find("iframe").attr("src", response.vr_url);
                    this.popupPlanZoom.find("img").attr("src", response.plan_url);

                    this.animate();
                    this.bindInterestButton();
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.error('AJAX Error:', textStatus, errorThrown);
                console.log('Response Text:', jqXHR.responseText); // Log the response text for debugging
            }
        });
    },

    preparePopup() {
        let formData = new FormData();
        formData.append('action', 'form_interest');
        formData.append('flat', this.data.id);

        $.ajax({
            type: 'POST',
            url: WEB_ROOT + '/modules/navigator/Navigator.async.php',
            data: formData,
            dataType: "json",
            processData: false,
            contentType: false,

            success: (response, textStatus, jqXHR) => {
                // console.log(response)
                if (response.view) {
                    this.popup.find('.title span').text(this.data.type);
                    this.popup.find('[block="space"]')
                        .html(response.view)
                        .find('nav .button.close').click((evt) => {
                        Popup.close($(evt.currentTarget));
                    })
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.error('AJAX Error:', textStatus, errorThrown);
                console.log('Response Text:', jqXHR.responseText); // Log the response text for debugging
            }
        });
    },

    isAvailable(data) {
        return data.state === 0;
    },

    isReserved(data) {
        return data.state === 1 || data.state === 2;
    },

    isSold(data) {
        return data.state === 3 || data.state === 2;
    },

    isInDev(data) {
        return data.state === 4 || data.state === 5;
    },

    resize() {
        const gap = window.innerWidth > window.innerHeight ? 88 : 0;
        this.height = this.el.find('[container]').outerHeight() + gap;
        this.el.removeAttr('style').css({height: this.height});
    }
}

export default Space;